import { combineReducers } from '@reduxjs/toolkit';
import user from './user';
import organization from './organization';

const reducer = combineReducers({
  user,
  organization
});

export default reducer;
